var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankingPair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.8125C20.3147 23.8125 23.8125 20.3147 23.8125 16C23.8125 11.6853 20.3147 8.1875 16 8.1875C11.6853 8.1875 8.1875 11.6853 8.1875 16C8.1875 20.3147 11.6853 23.8125 16 23.8125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0602 11.5811L17.0847 14.8947H20.4006C20.462 14.8947 20.4876 14.9773 20.4374 15.0141L17.7544 17.0621L18.7789 20.3757C18.7979 20.4371 18.7309 20.4873 18.6818 20.4494L15.9999 18.4025L13.3169 20.4505C13.2678 20.4884 13.2008 20.4371 13.2198 20.3768L14.2443 17.0632L11.5613 15.0152C11.5122 14.9773 11.5367 14.8958 11.5981 14.8958H14.914L15.9385 11.5822C15.9586 11.5197 16.0412 11.5197 16.0602 11.5811Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18666 15.9994H3.72238C3.72238 18.4648 5.72126 20.4637 8.18666 20.4637H9.59291C8.70898 19.1981 8.18666 17.6602 8.18666 15.9994ZM8.18666 15.9994H5.95452C3.48912 15.9994 1.49023 14.0006 1.49023 11.5352H9.59291C8.70898 12.8008 8.18666 14.3387 8.18666 15.9994ZM23.8117 15.9994C23.8117 17.6602 23.2893 19.1981 22.4054 20.4637H23.8117C26.2771 20.4637 28.2759 18.4648 28.2759 15.9994H23.8117ZM23.8117 15.9994C23.8117 14.3387 23.2893 12.8008 22.4054 11.5352H30.5081C30.5081 14.0006 28.5092 15.9994 26.0438 15.9994H23.8117Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankingPair);
export default __webpack_public_path__ + "static/media/ranking-pair.83dda7968d93d6c8c0d1cff64a993ee3.svg";
export { ForwardRef as ReactComponent };